import { create } from "apisauce";
import axios from "axios";

import TokenStorage from "./TokenStorage";
import { gaEventRequest } from "../components/GoogleTracking";
import notify from 'utils/modern_notify';

export let LOGOUT_FUNCTION = null;

export function setLogoutFunction(func) {
    if (LOGOUT_FUNCTION) return;

    LOGOUT_FUNCTION = func;
}

export class ProductionConfig {
    static url = "https://api3.azapfy.com.br";
    static domain = ProductionConfig.url.replace(/^https?:\/\//, "");
    static loaded = false;
    static isAlternative = false;

    static load() {
        if (this.loaded) return;

        const url = localStorage.getItem("prd_alt");

        if (url && /^https?:\/\//.test(url)) {
            this.url = url;
            this.domain = url.replace(/^https?:\/\//, "");
            this.isAlternative = true;
        }

        this.loaded = true;
    }

    static set(url) {
        if (!url || !/^https?:\/\//.test(url)) return false;

        localStorage.setItem("prd_alt", url);

        this.url = url;
        this.domain = url.replace(/^https?:\/\//, "");
        this.isAlternative = true;
        this.loaded = true;

        return true;
    }

    static reset() {
        localStorage.removeItem("prd_alt");

        this.url = "https://api3.azapfy.com.br";
        this.domain = this.url.replace(/^https?:\/\//, "");
        this.loaded = false;
        this.isAlternative = false;
    }
}

export let SHARED_BASE_URL = process.env.PRODUCTION_URL;

const getHost = (host) => {
    const hostname = window.location.hostname
    if (hostname.includes('web.azapfy')) {
        return ProductionConfig.url;
    }
    else if (hostname.includes('127.0.0')) {
        return 'http://homologacao3.azapfy.com.br'
    }
    else if (hostname.includes('testes.azapfy') || hostname.includes('testes-azapfy')) {
        return 'https://testes.azapfy.com.br'
    }
    else if (hostname.includes("web-homologacao.azapfy")) {
        return 'http://api3-homologacao.azapfy.com.br'
    }
    else if (hostname.includes("web-beta.azapfy.com.br")) {
        return ProductionConfig.url;
    }
    else if (hostname.includes("web-canario.azapfy.com.br")) {
        return 'https://api3-canario.azapfy.com.br'
    }
    else if (hostname.includes("auth-canario")) {
        return 'https://auth-canario.azapfy.com.br/'
    }
    else if (hostname.includes("web2.azapfy")) {
        return 'https://api3.azapfy.com.br'
    }
    return host
}

const getBaseUrl = (host) => {
    const baseUrl = getHost(host);
    SHARED_BASE_URL = baseUrl;
    return baseUrl;
}

ProductionConfig.load();

const api = axios.create({
    withCredentials: false,
    baseURL:
        process.env.NODE_ENV === "development"
            ? ProductionConfig.url
            : process.env.PRODUCTION_URL || getBaseUrl(process.env.REACT_APP_API_HOST_PRODUCTION),
    headers: { Accept: "application/json" },
});

export let ACCESS_TOKEN_MEMORY = "";

export function setAccessTokenInMemory(access) {
    ACCESS_TOKEN_MEMORY = access
}

function routeToGetAccessToken(url) {
    const auth = JSON.parse(localStorage.getItem("persist:auth"))
    const isSecure = true

    return (url?.startsWith("/api/usuarios/entrar") ||
        url?.startsWith("/auth/refresh") ||
        url?.startsWith("/secure/api/usuarios/entrar") ||
        url?.startsWith("/secure/auth/refresh") ||
        url?.startsWith("/api/usuarios/recuperarsenha") ||
        url?.startsWith("/api/usuarios/redefinir") ||
        !isSecure
    )
}

api.interceptors.request.use(
    async (config) => {
        // if (!(config.baseURL.includes("api3.azapfy.com.br") || config.baseURL.includes("interno.azapfy"))) {
        //     const token = TokenStorage.getAccessToken();

        //     if (token) {
        //         config.headers["Authorization"] = "Bearer " + token;
        //     }

        //     return config
        // }
        if (config.url?.includes("/api/usuarios/entrar") && !(config.url?.includes("cte.azapfy") || config.url?.includes("cte-homologacao"))) {
            fetch("https://api3.azapfy.com.br/api/usuarios/entrar", {
                body: JSON.stringify(config.data),
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept-Encoding": "gzip"
                }
            })
                .catch((e) => console.warn(e))
                .then(resp => resp.json())
                .then(resp => {
                    const access_token = resp?.dados?.usuario?.access_token
                    access_token && localStorage.setItem('access_token', access_token)
                })

        }

        if (!ACCESS_TOKEN_MEMORY && !routeToGetAccessToken(config.url)) {
            await refreshToken();
        }

        config.headers["Authorization"] = "Bearer " + ACCESS_TOKEN_MEMORY;

        config.headers["azsec"] = "none"

        const noSecure = config.url.startsWith("http") && !config.url.includes("azapfy")

        if (noSecure) {
            config.withCredentials = false
        }

        if (config.url.startsWith("/api/usuarios/entrar")
            || config.url.startsWith("/auth/refresh")
            || config.url.startsWith("/api/usuarios/carregarGrupo")) {
            config.url = "/secure" + config.url
            config.withCredentials = true
            config.headers["azsec"] = "sec"
        }

        else if (config.url.startsWith("/secure/api/usuarios/entrar")
            || config.url.startsWith("/secure/auth/refresh")
            || config.url.startsWith("/secure/api/usuarios/carregarGrupo")) {
            config.withCredentials = true
            config.headers["azsec"] = "sec"
        }

        else {
            try {
                const auth = JSON.parse(localStorage.getItem("persist:auth"))
                const grupo = auth?.grupo_ativo
                const isSuper = auth?.login == "\"super@azapfy.com\"";
                const isSecure = true
                if (isSecure || isSuper) {
                    if (config.url.startsWith("/api")) {
                        config.url = "/secure" + config.url
                        config.headers["azsec"] = "sec"
                    }
                    else if (config.url.startsWith("api")) {
                        config.url = "/secure/" + config.url
                        config.headers["azsec"] = "sec"
                    }
                }
            }
            catch { }
        }

        gaEventRequest(config?.url)

        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve();
        }
    });

    failedQueue = [];
};

api.interceptors.response.use(
    (response) => {
        if (response.status === 403) {
            if (typeof response.data) {
                notify(response.data);
                response.data = { status: false, mensagem: response.data, error: response.data }
                return response;
            }
        }
        return response;
    },
    async function (error) {
        const originalRequest = error.config;
        if (
            error.response.status === 401 &&
            originalRequest.url.includes("/auth/refresh")
        ) {
            notify("Não foi possível renovar sua sessão. Por favor, faça login novamente.", 1);
            LOGOUT_FUNCTION();
            return Promise.reject(error);
        }
        if (error.response.status === 403) {
            if (typeof error.response.data) {
                notify(error.response.data);
                error.response.data = { status: false, mensagem: error.response.data, error: error.response.data }
                return Promise.reject(error);
            }
            return Promise.reject(error);
        }
        if (error.response.status === 401 && !originalRequest._retry) {

            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                }).then(() => {
                    return api(originalRequest);
                }).catch(err => {
                    return Promise.reject(err);
                });
            }

            originalRequest._retry = true;
            isRefreshing = true;

            notify("Renovando sua sessão, por favor aguarde...", 1);

            return new Promise((resolve, reject) => {
                api.get('/auth/refresh')
                    .then((resp) => {
                        const access_token = resp.data.access_token
                        setAccessTokenInMemory(access_token)
                        notify("Sua sessão foi renovada com sucesso!", 2);
                        processQueue(null);
                        resolve(api(originalRequest));
                    })
                    .catch((err) => {
                        notify("Não foi possível renovar sua sessão. Por favor, faça login novamente.", 1);
                        processQueue(err);
                        LOGOUT_FUNCTION();
                        reject(err);
                    })
                    .finally(() => {
                        isRefreshing = false;
                    });
            });
        }

        return error.response;
    }
);

let refreshSubscribers = [];

const refreshToken = async () => {
    if (isRefreshing) {
        return new Promise((resolve) => {
            refreshSubscribers.push(() => {
                resolve();
            });
        });
    }

    isRefreshing = true;

    try {
        const response = await api.get('/auth/refresh');
        ACCESS_TOKEN_MEMORY = response.data.access_token;

        refreshSubscribers.forEach((callback) => callback());
        refreshSubscribers = [];
    } catch (error) {
        notify("Não foi possível renovar sua sessão. Por favor, faça login novamente.", 1);
        LOGOUT_FUNCTION();
        throw error;
    } finally {
        isRefreshing = false;
    }
};

const sauce = create({ axiosInstance: api });

export default sauce;
